export const siteMetaById: Record<string, { mark: string; bg: string; color: string }> = {
  google: { mark: 'G', bg: '#FFFFFF', color: '#1A73E8' },
  yelp: { mark: '✱', bg: '#FFFFFF', color: '#D32323' },
  facebook: { mark: 'f', bg: '#FFFFFF', color: '#1877F2' },
  bbb: { mark: 'BBB', bg: '#005A9C', color: '#FFFFFF' },
};

export function reviewSiteMeta(providerId: string, fallbackLabel: string) {
  return (
    siteMetaById[providerId] ?? {
      mark: fallbackLabel.charAt(0),
      bg: 'var(--cx-brand-button-hover-bg)',
      color: 'var(--cx-brand-button-text)',
    }
  );
}
